export enum FileExtension {
  SVG = 'svg',
  PNG = 'png',
  JPG = 'jpg',
  DOCX = 'docx',
  DOC = 'doc',
  PDF = 'pdf',
  XLS = 'xls',
  XLSX = 'xlsx',
  CSV = 'csv',
  PPT = 'ppt',
  PPTX = 'pptx',
}
